import React from 'react';
import PropTypes from 'prop-types';

const ACTIONS = {
  SET_ANCHOR_ELEMENT: 'set-anchor-element',
};

const initialState = {
  anchorEl: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_ANCHOR_ELEMENT:
      return { ...state, anchorEl: action.anchorEl };
    default:
      throw new Error(`Unknown FilterProvider action, ${action.type}`);
  }
};

const KabobMenuContext = React.createContext({});

export const KabobMenuProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const value = React.useMemo(
    () => ({
      ...state,
      setAnchorEl: elem => {
        dispatch({ type: ACTIONS.SET_ANCHOR_ELEMENT, anchorEl: elem });
      },
    }), [dispatch, state],
  );

  return (
    <KabobMenuContext.Provider value={value}>
      {children}
    </KabobMenuContext.Provider>
  );
};

export const useKabobMenuContext = () => {
  const context = React.useContext(KabobMenuContext);

  if (context === undefined) {
    throw new Error('useKabobMenuContext must be used within a KabobMenuProvider');
  }

  return context;
};

KabobMenuProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
